<template>
	<div class="hello">
		<!-- 粒子特效背景 -->
		<vue-particles
			color="#05A5E9"
			:particleOpacity="0.7"
			:particlesNumber="80"
			shapeType="circle"
			:particleSize="4"
			linesColor="#02FFFF"
			:linesWidth="1"
			:lineLinked="true"
			:lineOpacity="0.4"
			:linesDistance="150"
			:moveSpeed="2"
			:hoverEffect="true"
			hoverMode="grab"
			:clickEffect="true"
			clickMode="push"
			class="lizi"
		></vue-particles>
		<div class="login-container">
			<div class="login-content">
				<div class="login-box">
					<div class="title-container">
						<div class="zgj" style="text-align: center"><img src="./zgj-logo.svg" width="250px" height="86px" alt /></div>
					</div>
					<div class="box-container">
						<div class="box-title">
							<div class="title-tab fz20" :class="selectIndex == 2 ? 'active' : ''" @click="changeIndex(2)">
								项目端登录
								<p id="show2" v-show="selectIndex == 2" class="p_line animate__animated" :class="slideClass"></p>
							</div>
							<div class="title-tab fz20" :class="selectIndex == 1 ? 'active' : ''" @click="changeIndex(1)">
								企业端登录
								<p id="show1" v-show="selectIndex == 1" class="p_line animate__animated" :class="slideClass"></p>
							</div>
							<div class="title-tab fz20" :class="selectIndex == 0 ? 'active' : ''" @click="changeIndex(0)">
								二维码登录
								<p id="show0" v-show="selectIndex == 0" class="p_line animate__animated" :class="slideClass"></p>
							</div>
						</div>
						<div class="box-cont" v-if="selectIndex == 1 || selectIndex == 2">
							<div class="login_user">
								<div class="imgs"><img src="../../assets/images/login_user.png" /></div>
								<div class="inputs fz20">
									<el-input class="input" ref="username" v-model="username" placeholder="请输入用户名" name="username" type="text" tabindex="1" auto-complete="on" />
								</div>
							</div>
							<div class="login_user pass">
								<div class="imgs"><img src="../../assets/images/login_pass.png" /></div>
								<div class="inputs fz20">
									<el-input
										class="input"
										ref="password"
										v-model="password"
										placeholder="请输入密码"
										:type="isPass ? 'password' : ''"
										name="password"
										tabindex="2"
										auto-complete="on"
										@keyup.native="checkCapslock"
										@blur="isCapsLock = false"
										@keyup.enter.native="fnLogin"
									/>
								</div>
								<div class="imgs">
									<img class="eye" v-if="isPass" @click="isPass = !isPass" src="../../assets/images/eye_close.png" />
									<img class="eye" v-else @click="isPass = !isPass" src="../../assets/images/eye_open.png" />
								</div>
								<div class="tips" v-if="isCapsLock">! 大写已锁定</div>
							</div>
							<div class="login_submit"><div @click="fnLogin">登 录</div></div>
						</div>
						<!-- <div class="code-box" v-else @mouseenter="isRefresh=true" @mouseleave="isRefresh=false"> -->
						<div class="code-box" v-else>
							<img :src="codePath" />
							<div class="code_txt">扫一扫，APP登录 <span @click="fnGetQRcode('refresh')">点击刷新</span></div>
							<div class="code_refresh" v-if="isRefresh">
								<span v-if="isPast">二维码已失效</span>
								<div class="refresh_btn" v-if="isPast" @click="fnGetQRcode('refresh')">点击刷新</div>
								<span class="refresh_btn" v-if="is_scan">已扫码</span>
								<span class="refresh_btn" v-if="tokenInfo">授权成功</span>
							</div>
						</div>
					</div>
				</div>
				<div class="copy_box">
					<div class="copy">渝ICP备2025076929号</div>
					<div class="copy">Version：1.0.1</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import request from '@/utils/request';
import { setToken, setUserInfo, setEnterToken, setEnterInfo } from '@/utils/auth';
import APP from '@/utils/base';

export default {
	provide() {
		return {
			reload: this.reload
		};
	},
	data() {
		return {
			slideClass: '',
			isRefresh: false, // 二维码蒙层
			redirect: undefined,
			isRouterAlive: true,
			isPass: true, // 密码是否显示
			selectIndex: 2, // 默认选择项目端 2-项目端，1-企业端，0-二维码登录
			username: '', // 输入框用户名
			password: '', // 输入框密码
			isCapsLock: false, // 密码框大写是否开启
			flag: '', //扫码登录 唯一标识
			codePath: '', //二维码图片
			expire: 0, //二维码过期时间
			is_scan: false, //二维码是否扫描
			tokenInfo: '' ,//扫码授权信息
			isPast: false,// 二维码是否过期
		};
	},
	watch: {
		$route: {
			handler: function(route) {
				this.redirect = route.query && route.query.redirect;
			},
			immediate: true
		}
	},
	mounted() {
		if (this.username === '') {
			this.$refs.username.focus();
		} else if (this.password === '') {
			this.$refs.password.focus();
		}
	},
	methods: {
		changeIndex(index) {
			//改变样式
			if (this.selectIndex != index) {
				this.slideClass = this.selectIndex < index ? 'animate__slideInRight' : 'animate__slideInLeft';
				this.selectIndex = index;
			}
			if(index == 0){
				this.fnGetQRcode()
			}
		},
		//获取二维码base64图片
		fnGetQRcode(_type){
			if(_type == 'refresh'){
				this.expire = 0
				this.isPast = false
				this.is_scan = false
				this.isRefresh = false
			}
			let that = this;
			request({
				url: '/genQrcode',
				method: 'GET',
				notLoading: true,
			})
			.then(res => {
				that.codePath = 'data:image/png;base64,' + res.data.qrcode;
				that.flag = res.data.flag;
				that.expire = res.data.expire;
				// 判断是否扫码
				that.fnGetIsLogin()
			})
			.catch(err => {});
		},
		// 判断是否扫码
		fnGetIsLogin(){
			let that = this;
			request({
				url: '/qrcodeLogin',
				method: 'POST',
				data: { flag: that.flag }
			})
			.then(res => {
				that.is_scan = res.data.is_scan;
				that.isRefresh = true
				if (res.data.is_scan == false) {
					that.tokenInfo = res.data.tokenInfo;
					if(that.tokenInfo.bind == 1){
						setToken(res.data.tokenInfo.token);
						setUserInfo(res.data.tokenInfo);
						this.$router.push({ path: this.redirect || '/index' });
					}else{
						// 企业端登录
						setEnterToken(res.data.tokenInfo.token);
						setEnterInfo(res.data.tokenInfo);
						this.$router.push({ path: '/enter' });
					}
				}else{
					if(that.selectIndex == 0){
						that.fnGetIsLogin()
					}
				}
			})
			.catch(err => {
				if (new Date().getTime() > this.expire * 1000){
					that.isPast = true
					that.isRefresh = true
					that.is_scan = false
				}else{
					if(that.selectIndex == 0){
						that.fnGetIsLogin()
					}
				}
			});
		},
		reload() {
			this.isRouterAlive = true;
		},
		fnLogin() {
			let reg = /^\d{1,}$/;
			if (this.username === '' || this.password === '') {
				this.$message.warning('用户名或密码不能为空！');
				return;
			}
			// if(!reg.test(this.username)){
			// 	this.$message.warning('用户名只能为数字！')
			// 	return
			// }
			// if (!reg.test(this.password)) {
			// 	this.$message.warning('密码只能是数字！');
			// 	return;
			// }
			let _obj = {
				username: this.username,
				password: this.password,
				type: this.selectIndex
			};
			request({
				url: '/login',
				method: 'POST',
				data: _obj
			})
				.then(res => {
					if (this.selectIndex == 2) {
						// 项目端
						setToken(res.data.token);
						setUserInfo(res.data);
						this.$router.push({ path: this.redirect || '/index' });
					} else if (this.selectIndex == 1) {
						// 企业端登录
						setEnterToken(res.data.token);
						setEnterInfo(res.data);
						this.$router.push({ path: '/enter' });
					}
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
		// 监测是否开启大小写
		checkCapslock({ shiftKey, key } = {}) {
			if (key && key.length === 1) {
				if ((shiftKey && key >= 'a' && key <= 'z') || (!shiftKey && key >= 'A' && key <= 'Z')) {
					this.isCapsLock = true;
				} else {
					this.isCapsLock = false;
				}
			}
			if (key === 'CapsLock' && this.isCapsLock === true) {
				this.isCapsLock = false;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/base.scss';
@import '@/styles/mixin.scss';

.hello {
	width: 100vw;
	height: 100vh;
	background: url('../../assets/images/app_bg.jpg') no-repeat;
	background-size: 100% 100%;
	position: relative;
	overflow: hidden;
}

.lizi {
	position: absolute;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	z-index: 0;
}

.login-container {
	width: 1920px;
	height: 1080px;
	position: relative;
	overflow: hidden;

	.login-content {
		position: absolute;
		top: 0;
		right: -20px;
		left: 0;
		bottom: 0;
		overflow-x: hidden;
		overflow-y: auto;

		.login-box {
			width: 500px;
			height: 500px;
			padding: 10px;
			position: absolute;
			top: 140px;
			left: 710px;

			.title-container {
				width: 500px;
				height: 128px;
				color: #ffffff;

				.zgj {
					margin-bottom: 20px;
					height: 120px;
				}

				.title {
					height: 24px;
					line-height: 24px;
					text-align: right;
				}
			}

			.box-container {
				width: 500px;
				height: 380px;

				.box-title {
					width: 500px;
					height: 60px;
					@include flex-box(space-between);

					.title-tab {
						width: 163px;
						height: 60px;
						line-height: 60px;
						text-align: center;
						cursor: pointer;
						display: inline-block;
						color: #ffffff;
					}

					.active {
						color: #27ded9;
					}
				}

				.box-cont {
					width: 480px;
					height: 240px;
					margin: 0 auto;

					.login_user {
						width: 440px;
						height: 60px;
						margin: 30px auto;
						border-bottom: 1px solid #ffffff;
						display: inline-block;
						@include flex-box;

						&.pass {
							position: relative;
						}

						.imgs {
							display: inline-block;
							width: 60px;
							height: 60px;
							text-align: center;

							img {
								width: 30px;
								margin: 15px auto;
							}

							.eye {
								width: 20px;
								margin: 25px auto 15px;
							}
						}

						.inputs {
							width: 380px;
							height: 60px;
							display: inline-block;
							flex: 1;

							input {
								color: #ffffff;
								margin-left: 10px;
								height: 60px;
								border: none;
								background: transparent;
							}
						}

						.tips {
							position: absolute;
							right: -100px;
							top: 16px;
							font-size: 16px;
							color: #ff4949;
						}
					}

					.login_submit {
						width: 380px;
						height: 50px;
						font-size: 20px;
						margin: 20px auto 0;
						border-radius: 10px;
						background-color: rgba(40, 180, 250, 0.5);
						text-align: center;
						line-height: 50px;
						color: #ffffff;
					}
				}

				.code-box {
					margin: 40px auto 0;
					width: 300px;
					height: 340px;
					position: relative;

					img {
						width: 300px;
						height: 300px;
					}

					.code_txt {
						width: 300px;
						height: 40px;
						line-height: 40px;
						text-align: center;
						color: #ffffff;
						font-size: 20px;
						span{
							color: rgba(40, 150, 250, 0.9);
						}
					}

					.code_refresh {
						width: 300px;
						height: 300px;
						background-color: rgba(0, 0, 0, 0.6);
						position: absolute;
						color: #ffffff;
						top: 0;
						left: 0;
						@include flex-box(center, center, column);

						.refresh_btn {
							min-width: 80px;
							height: 35px;
							font-size: 16px;
							border-radius: 5px;
							margin: 5px 0;
							cursor: pointer;
							background-color: rgba(40, 150, 250, 0.8);
							text-align: center;
							line-height: 35px;
							color: #ffffff;
						}

						span {
							height: 25px;
							line-height: 25px;
						}
					}
				}
			}
		}

		.copy_box {
			width: 300px;
			height: 50px;
			line-height: 50px;
			position: absolute;
			left: 810px;
			bottom: 20px;
			color: #ffffff;
			@include flex-box(space-between);
		}
	}
}

.login-container /deep/ {
	.el-input__inner {
		font-size: 20px !important;
		color: #ffffff;
		height: 60px;
		border: none;
		background: transparent;
		padding: 10px !important;
		border-radius: 0 !important;
	}
}

.p_line {
	height: 10px;
	width: 100%;
	margin-top: -5%;
	background: url('../../assets/images/ny_div.png') no-repeat center bottom;
}
</style>



// WEBPACK FOOTER //
// src/views/Login/login.vue